import type { ScheduleType } from '@liza/ui/utils/schedulePicker';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/** Display label per schedule mode — shared by the mode tabs and the collapsed-header fallback. */
export function useScheduleTypeLabels(): Record<ScheduleType, string> {
  const { t } = useTranslation('common');
  return useMemo(
    () => ({
      once: t('once'),
      simple: t('modeDaysOfWeek'),
      daysPerWeek: t('daysPerWeek'),
      custom: t('modeEvery'),
    }),
    [t],
  );
}
